import * as token from "@universityofmaryland/web-token-library";
import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import { combineStyles } from "@universityofmaryland/web-utilities-library/styles";
import { close_large } from "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-styles-library/element";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-styles-library/animation";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import "@universityofmaryland/web-icons-library/arrows";
import "@universityofmaryland/web-utilities-library/performance";
import "@universityofmaryland/web-utilities-library/accessibility";
import "../../../atomic/animations/brand/card-stack.js";
import "@universityofmaryland/web-styles-library";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "@universityofmaryland/web-utilities-library/theme";
import "../../../atomic/layout/block/stacked.js";
import { createModal } from "../../../atomic/layout/overlay/modal.js";
import "../../../atomic/layout/person/columns.js";
import "@universityofmaryland/web-icons-library/social";
import "@universityofmaryland/web-utilities-library/string";
import "@universityofmaryland/web-utilities-library/animation";
import "../../../atomic/text-lockup/small.js";
const createCompositeCarouselFullScreen = ({
  content,
  callback
}) => {
  const modal = createModal({ content, onHide: callback });
  const modalEvents = modal.events;
  const closeButtonModel = new ElementBuilder("button").withClassName("carousel-fixed-screen-button").withAttribute("type", "button").withAria({ label: "Close" }).withHTML(close_large).withStyles({
    element: {
      position: "absolute",
      top: "10px",
      right: "10px",
      [`@media (${token.media.queries.tablet.min})`]: {
        top: "calc(10vh - 22px)",
        right: "calc(10vw - 22px)"
      },
      "& svg": {
        fill: token.color.white,
        width: "20px",
        height: "20px"
      }
    }
  }).on("click", () => {
    if (!modalEvents) {
      return;
    }
    modalEvents.hide();
  }).build();
  modal.element.appendChild(closeButtonModel.element);
  const show = modalEvents ? modalEvents.show : () => {
  };
  const hide = modalEvents ? modalEvents.hide : () => {
  };
  return {
    element: modal.element,
    styles: combineStyles(modal.styles, closeButtonModel.styles),
    events: { show, hide }
  };
};
export {
  createCompositeCarouselFullScreen
};
//# sourceMappingURL=full-screen.js.map
